// extracted by mini-css-extract-plugin
export default {"products":"Tt-z","card":"Ut-z","oosMessaging":"Vt-z"};